module.exports = __webpack_public_path__ + "img/ms-icon.0287fa48.png";